import { createContext, useContext, useState } from "react";

const AuthContext = createContext(null);

const API = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("rira_token") || null);
  const [user,  setUser]  = useState(() => {
    try { return JSON.parse(localStorage.getItem("rira_user")); } catch { return null; }
  });

  const isSubscribed = Boolean(
    user?.subscription_expires &&
    new Date(user.subscription_expires) > new Date()
  );

  const persist = (tok, usr) => {
    localStorage.setItem("rira_token", tok);
    localStorage.setItem("rira_user", JSON.stringify(usr));
    setToken(tok);
    setUser(usr);
  };

  const login = async (email, password) => {
    const res = await fetch(`${API}/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.detail || "Login failed.");
    persist(data.token, data.user);
  };

  const register = async (name, email, password) => {
    const res = await fetch(`${API}/auth/register`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name, email, password }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.detail || "Registration failed.");
    // Return raw data — caller decides when to persist (after email verification step)
    return data;
  };

  const completeAuth = (tok, usr) => persist(tok, usr);

  const subscribe = async (plan) => {
    const res = await fetch(`${API}/auth/subscribe`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ plan }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.detail || "Subscription failed.");
    const updated = { ...user, ...data.user };
    localStorage.setItem("rira_user", JSON.stringify(updated));
    setUser(updated);
  };

  const logout = () => {
    localStorage.removeItem("rira_token");
    localStorage.removeItem("rira_user");
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, isSubscribed, login, register, completeAuth, subscribe, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
